import { motion } from "framer-motion";
import HelloPanda from "../../assets/images/Panda/MagicPanda2.png";

const SectionBannerAbouts: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white via-[#fff8f8] to-white">
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(255,255,255,0.94),rgba(255,247,247,0.98))]"></div>
      <div className="absolute left-10 top-20 h-72 w-72 animate-blob rounded-full bg-red-200/20 blur-3xl"></div>
      <div className="animation-delay-2000 absolute right-10 top-40 h-72 w-72 animate-blob rounded-full bg-rose-200/20 blur-3xl"></div>
      <div className="animation-delay-4000 absolute bottom-20 left-1/2 h-72 w-72 animate-blob rounded-full bg-red-100/30 blur-3xl"></div>

      <div className="container relative z-10 mx-auto px-4 py-14 lg:py-18">
        <div className="grid items-center gap-10 lg:grid-cols-[minmax(0,0.96fr)_minmax(0,1.04fr)] lg:gap-10 xl:gap-14">
          <motion.div
            className="flex justify-center lg:justify-start"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="w-full max-w-[620px] rounded-[30px] border border-red-100 bg-white/92 px-7 py-8 text-left shadow-[0_24px_70px_rgba(127,29,29,0.08)] backdrop-blur-md sm:px-8 lg:px-9">
              <p className="mb-4 text-[14px] font-semibold uppercase tracking-[0.18em] text-red-600">
                TrioCore Solutions
              </p>

              <h2 className="text-[28px] font-semibold leading-[1.16] text-[#2f1a1a] sm:text-[31px] xl:text-[35px]">
                Đồng Hành Công Nghệ <span className="text-[#dc2626]">–</span>{" "}
                <span className="text-[#b91c1c]">Song Hành Giá Trị</span>
              </h2>

              <p className="mt-5 text-[15px] leading-8 text-slate-700 sm:text-[16px] xl:text-[17px] xl:leading-9">
                Là đơn vị chuyên sâu về giải pháp công nghệ và số hóa đa nền tảng. TrioCore mang
                đến hệ sinh thái dịch vụ khép kín bao gồm: Phát triển Web/App, Chuyển đổi số doanh
                nghiệp và Digital Marketing. Chúng tôi tập trung vào các giải pháp thực tế, bám sát
                bài toán kinh doanh để tối ưu hóa chi phí và hiệu quả đầu tư cho bạn.
              </p>
            </div>
          </motion.div>

          <motion.div
            className="flex justify-center"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="relative h-[460px] w-full max-w-[560px] lg:h-[520px]">
              <div className="absolute inset-0 rounded-full bg-gradient-to-r from-red-300/20 to-rose-500/20 blur-3xl"></div>

              <motion.div
                className="absolute left-10 top-10 h-3 w-3 rounded-full bg-red-400"
                animate={{
                  y: [-20, 20, -20],
                  x: [-10, 10, -10],
                  scale: [1, 1.5, 1],
                  opacity: [0.5, 1, 0.5],
                }}
                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
              />

              <motion.div
                className="absolute right-8 top-32 h-2 w-2 rounded-full bg-rose-400"
                animate={{
                  y: [20, -20, 20],
                  x: [10, -10, 10],
                  scale: [1, 2, 1],
                  opacity: [0.3, 0.8, 0.3],
                }}
                transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
              />

              <motion.div
                className="absolute bottom-20 left-16 h-4 w-4 rounded-full bg-red-300"
                animate={{
                  y: [15, -15, 15],
                  scale: [1, 1.3, 1],
                  opacity: [0.4, 0.9, 0.4],
                }}
                transition={{ duration: 2.8, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
              />

              <motion.div
                className="absolute right-20 top-24 h-2.5 w-2.5 rounded-full bg-red-500"
                animate={{
                  y: [-15, 15, -15],
                  x: [15, -15, 15],
                  opacity: [0.6, 1, 0.6],
                }}
                transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
              />

              <motion.div
                className="absolute inset-0"
                animate={{ rotate: 360 }}
                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
              >
                <div className="absolute left-12 top-16 h-6 w-6 rounded-full border-2 border-red-300 opacity-40"></div>
                <div className="absolute bottom-24 right-16 h-8 w-8 rounded-full border-2 border-rose-300 opacity-30"></div>
              </motion.div>

              <motion.div
                className="absolute right-12 top-0 text-2xl text-yellow-400"
                animate={{
                  scale: [1, 1.5, 1],
                  rotate: [0, 180, 360],
                  opacity: [0.5, 1, 0.5],
                }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
              >
                ✨
              </motion.div>

              <motion.div
                className="absolute left-8 top-0 text-xl text-red-400"
                animate={{
                  scale: [1, 1.3, 1],
                  rotate: [0, -180, -360],
                  opacity: [0.4, 0.9, 0.4],
                }}
                transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut", delay: 0.7 }}
              >
                ⭐
              </motion.div>

              <motion.div
                className="absolute left-1/2 top-1/2 h-16 w-16"
                style={{ transformOrigin: "center", x: "-50%", y: "-50%" }}
                animate={{ rotate: 360 }}
                transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
              >
                <motion.div
                  className="absolute flex h-16 w-16 items-center justify-center"
                  style={{ x: -70, y: -220 }}
                  animate={{ rotateZ: [-8, 8, -8], scale: [1, 1.1, 1] }}
                  transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut" }}
                >
                  <div className="absolute inset-0 animate-ping rounded-full bg-gradient-to-r from-red-400 to-rose-500 opacity-70 blur-md"></div>
                  <div className="absolute inset-1 rounded-full bg-white shadow-[inset_0_0_15px_rgba(220,38,38,0.28)]"></div>
                  <span className="relative text-3xl drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)]">
                    🌐
                  </span>
                </motion.div>
              </motion.div>

              <motion.div
                className="absolute left-[calc(50%+50px)] top-1/2 h-16 w-16"
                style={{ transformOrigin: "center", x: "-100%", y: "-100%" }}
                animate={{ rotate: -360 }}
                transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
              >
                <motion.div
                  className="absolute flex h-16 w-16 items-center justify-center rounded-2xl border border-white/60 bg-gradient-to-br from-red-50/80 via-white/60 to-rose-100/70 p-3 shadow-[0_10px_30px_rgba(220,38,38,0.18)] backdrop-blur-md"
                  style={{ x: 220, y: -70 }}
                  animate={{ rotateY: [10, -10, 10], rotateX: [-8, 8, -8], scale: [1, 1.1, 1] }}
                  transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                >
                  <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-red-300/20 to-rose-300/20 blur-lg"></div>
                  <span className="relative text-3xl drop-shadow-[0_4px_4px_rgba(0,0,0,0.25)]">
                    🎨
                  </span>
                </motion.div>
              </motion.div>

              <motion.img
                src={HelloPanda}
                alt="TrioCore Solutions Mascot"
                className="absolute bottom-0 left-1/2 h-auto w-[360px] -translate-x-1/2 drop-shadow-2xl sm:w-[410px] lg:w-[450px]"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SectionBannerAbouts;
